import { derived, writable } from 'svelte/store';
export function readableWritable(value) {
    const write = writable(value);
    const read = derived(write, $value => $value);
    return { read, write };
}
